<template>
    <main>
        <page-header-compact>
            Configuración de Asignación de Áreas
        </page-header-compact>

        <div class="container-fluid">
            <div class="card mt-4">
                <div class="card-body">

                    <data-grid :data="pagination"
                           @changePage="changePage($event)"
                           @perPageChange="perPageChange($event)"
                           @search="search($event)">
                            <template #grid>
                                <grid-table>
                                    <template #head>
                                        <grid-cell-header class="bg-light"  v-for="(h,i) in headers" :key="`h_${i}`">{{h}}</grid-cell-header>
                                    </template>
                                    <template #body>
                                        <grid-row v-for="(item, i) in pagination.data" :key="`d_${i}`">
                                            <grid-cell class="text-center small">
                                                {{item.id}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.fecha}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.estado}}
                                            </grid-cell>

                                            <grid-cell class="text-center   ">
                                                <div class="form-group px-1">
                                                    <button @click="eliminarAsignacion(item.id);" class="btn btn-outline-danger lift" >
                                                        <i class="fa fa-trash-alt fa-fw"></i>Eliminar
                                                    </button>

                                                    <router-link
                                                        class="btn btn-primary"
                                                        :to="{name:'asignacion-areas.index',params:{'id_asignacion_area':item.id}}"
                                                        >Asignaciones
                                                    </router-link>
                                                </div>
                                                
                                            </grid-cell>

                                            
                                           
                                         

                                        </grid-row>
                                    </template>
                                </grid-table>
                            </template>
                            <template #action-button>
                                <button  class="btn btn-info btn-sm shadow-sm mb-2" type="button" data-toggle="modal" data-target="#modalAsignacionAreas">
                                    Nuevo &nbsp;<i class="fas fa-plus"></i>
                                </button>

                            </template>
                    </data-grid>

                   <modalAsignacionAreas ref="modalAsignacionAreas" v-on:cargar-asignacion-areas="getAsignacionAreas"></modalAsignacionAreas>
                    

                </div>
            </div>
           
        </div>

    </main>
</template>
<script>

import PageHeaderCompact from "../../../../../../components/layouts/content/page-header-compact";
import DataGrid from "../../../../../../components/common/utilities/DataGrid/DataGrid";
import GridTable from "../../../../../../components/common/utilities/DataGrid/GridTable";
import GridCellHeader from "../../../../../../components/common/utilities/DataGrid/GridCellHeader";
import GridRow from "../../../../../../components/common/utilities/DataGrid/GridRow";
import GridCell from "../../../../../../components/common/utilities/DataGrid/GridCell";

import Toast from '../../../../../../components/common/utilities/toast';
import modalAsignacionAreas from "./modalAsignacionAreas";
import $ from 'jquery';
import Swal from "sweetalert2";

import asignacionAreasService from '../../../../../../services/asignacionAreasService';

export default {
    components: {
        PageHeaderCompact,GridCell, GridRow, GridCellHeader, GridTable, DataGrid, modalAsignacionAreas
    },
    data(){
        return {
            asignacionareas:{},
            headers : [
                'Id','Fecha','Estado','Opción'
           ],
           pagination : {
               data : [],
               current_page : 1,
               page : 1,
               per_page : 5,
               search : '',
               total: '',
           }
        }
    },
    methods : {
        async getAsignacionAreas(){
            try {
                this.LoaderSpinnerShow();
                const response = (await asignacionAreasService.list(this.pagination.search, this.pagination))?.data;
                this.asignacionareas = response.data;
                console.log(response.data);
                this.pagination.data = response.data;
                this.pagination.current_page  = response.current_page;
                this.pagination.total = response.total;
                this.LoaderSpinnerHide();

            }catch (e) {
                console.error(e);
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        changePage(page) {
            this.pagination.page = page;
            this.getAsignacionAreas();
        },
        perPageChange(per_page) {
            this.pagination.per_page = per_page;
            this.pagination.page = 1;
            this.getAsignacionAreas();
        },
        search(query){
            this.pagination.search = query;
            this.pagination.page = 1;
            this.getAsignacionAreas();
        },
        async eliminarAsignacion(id){
            this.LoaderSpinnerShow();
            await asignacionAreasService.delete(id);
            this.LoaderSpinnerHide();
            Swal.fire('Datos eliminados con exito','', 'success');
           // this.limpiarCampos();
            $('#modalAntecedente').modal('hide');
            this.getAsignacionAreas();
        }

    },
    async created(){
       await this.getAsignacionAreas();
    }
}
</script>
